import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Box from "@mui/material/Box";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import PropTypes from "prop-types";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const phcolumn = [
  { field: "stt", headerName: "stt", width: 70, headerAlign: "center" },
  {
    field: "sophuhieu",
    headerName: "Số phù hiệu",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "loaiphuhieu",
    headerName: "Loại phù hiệu",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "mauphuhieu",
    headerName: "Phù hiệu",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 120,
    headerAlign: "center",
    //valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 120,
    headerAlign: "center",
    //valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "coquancapphep",
    headerName: "Cơ quan cấp phép",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "trangthaiphuhieu",
    headerName: "Trạng thái",
    width: 150,
    headerAlign: "center",
  },
];
const Capnhatphuhieu = React.memo(function Capnhatphuhieu(props) {
  const { bienkiemsoat } = props;
  const [list_id, setList_id] = React.useState(0);
  const [sophuhieu, setSophuhieu] = React.useState("");
  const [coquancapphep, setCoquancapphep] = React.useState("");
  const [ngaycap, setNgaycap] = React.useState(dayjs());
  const [ngayhethan, setNgayhethan] = React.useState(null);
  const [mauphuhieu, setMauphuhieu] = React.useState([]);
  const [mauphuhieuvalue, setMauphuhieuvalue] = React.useState(null);
  const [loaiphuhieu, setLoaiphuhieu] = React.useState([]);
  const [loaiphuhieuvalue, setLoaiphuhieuvalue] = React.useState(null);
  const [trangthai, setTrangthai] = React.useState([]);
  const [trangthaivalue, setTrangthaivalue] = React.useState(null);
  const [listphuhieu, setListphuhieu] = React.useState([]);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getdmphuhieuhieuluc = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmphuhieuhieuluc?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setMauphuhieu(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdmloaiphuhieu = () => {
    var url =
      Config.backend + "/api/Phuongtien/getdmloaiphuhieu?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaiphuhieu(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdmtrangthaiphuhieu = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmtrangthaiphuhiep?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTrangthai(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getphuhieutheobks = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getphuhieutheobks?bienkiemsoat=" +
      bienkiemsoat +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setListphuhieu(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const themphuhieu = () => {
    var ngaycapph =
      ngaycap.$y +
      "-" +
      String(ngaycap.$M + 1).padStart(2, "0") +
      "-" +
      ngaycap.$D;
    var ngayhethanph = null;
    if (ngayhethan) {
      ngayhethanph =
        ngayhethan.$y +
        "-" +
        String(ngayhethan.$M + 1).padStart(2, "0") +
        "-" +
        ngayhethan.$D;
    }
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/themphuhieuphuongtien";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          bienkiemsoat: bienkiemsoat,
          sophuhieu: sophuhieu,
          coquancapphep: coquancapphep,
          ngaycap: ngaycapph,
          ngayhethan: ngayhethanph,
          mauphuhieu_id: mauphuhieuvalue.id,
          loaiphuhieu_id: loaiphuhieuvalue.id,
          trangthai_id: trangthaivalue.id,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            setMessageValidate(data);
            showNotificationValidate();
            getphuhieutheobks();
            setDisableBT(true);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const capnhatphuhieu = () => {
    var ngaycapph =
      ngaycap.$y +
      "-" +
      String(ngaycap.$M + 1).padStart(2, "0") +
      "-" +
      ngaycap.$D;
    var ngayhethanph = null;
    if (ngayhethan) {
      ngayhethanph =
        ngayhethan.$y +
        "-" +
        String(ngayhethan.$M + 1).padStart(2, "0") +
        "-" +
        ngayhethan.$D;
    }
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/capnhatphuhieuphuongtien";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: list_id,
          bienkiemsoat: bienkiemsoat,
          sophuhieu: sophuhieu,
          coquancapphep: coquancapphep,
          ngaycap: ngaycapph,
          ngayhethan: ngayhethanph,
          mauphuhieu_id: mauphuhieuvalue.id,
          loaiphuhieu_id: loaiphuhieuvalue.id,
          trangthai_id: trangthaivalue.id,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            setMessageValidate(data);
            showNotificationValidate();
            getphuhieutheobks();
            setDisableBT(true);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const xoaphuhieu = () => {
    var url = Config.backend + "/api/Phuongtien/xoaphuhieuphuongtien";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: list_id,
        bienkiemsoat: bienkiemsoat,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setMessageValidate(data);
          showNotificationValidate();
          getphuhieutheobks();
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (sophuhieu.trim() === "") {
      return Error.ER0065;
    }
    if (coquancapphep.trim() === "") {
      return Error.ER0066;
    }
    if (!ngaycap) {
      return Error.ER0067;
    }
    if (!mauphuhieuvalue.id) {
      return Error.ER0068;
    }
    if (!loaiphuhieuvalue.id) {
      return Error.ER0069;
    }
    if (!trangthaivalue.id) {
      return Error.ER0070;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getdmphuhieuhieuluc();
    getdmloaiphuhieu();
    getphuhieutheobks();
    getdmtrangthaiphuhieu();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số phù hiệu"
                variant="outlined"
                size="small"
                value={sophuhieu}
                onChange={(event) => {
                  setSophuhieu(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Cơ quan cấp phép"
                variant="outlined"
                size="small"
                value={coquancapphep}
                onChange={(event) => {
                  setCoquancapphep(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp"
                  value={ngaycap}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaycap(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày hết hạn"
                  value={ngayhethan}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayhethan(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={mauphuhieuvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={mauphuhieu}
                getOptionLabel={(option) => option.mau || ""}
                onChange={(event, value) => {
                  setMauphuhieuvalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setMauphuhieuvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Màu phù hiệu"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={loaiphuhieuvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={loaiphuhieu}
                getOptionLabel={(option) => option.loaiphuhieu || ""}
                onChange={(event, value) => {
                  setLoaiphuhieuvalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaiphuhieuvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại phù hiệu"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={trangthaivalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={trangthai}
                getOptionLabel={(option) => option.trangthaiphuhieu || ""}
                onChange={(event, value) => {
                  setTrangthaivalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setTrangthaivalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Trạng thái"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
            <div style={{ height: 220, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={listphuhieu}
                columns={phcolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                sx={datagridSx}
                hideFooter={true}
                onRowClick={(params) => {
                  setList_id(params.row.id);
                  setSophuhieu(params.row.sophuhieu);
                  setCoquancapphep(params.row.coquancapphep);
                  let [day, month, year] = params.row.ngaycap.split("/");
                  setNgaycap(dayjs(year + "-" + month + "-" + day));
                  if (params.row.ngayhethan !== null) {
                    let [d, m, y] = params.row.ngaycap.split("/");
                    setNgayhethan(dayjs(y + "-" + m + "-" + d));
                  } else {
                    setNgayhethan(null);
                  }
                  setMauphuhieuvalue({
                    id: params.row.mauphuhieu_id,
                    mau: params.row.mauphuhieu,
                  });
                  setLoaiphuhieuvalue({
                    id: params.row.loaiphuhieu_id,
                    loaiphuhieu: params.row.loaiphuhieu,
                  });
                  setTrangthaivalue({
                    id: params.row.trangthai_id,
                    trangthaiphuhieu: params.row.trangthaiphuhieu,
                  });
                  setDisableBT(false);
                }}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: quickSearchToolbar }}
              />
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <GridItem xs={12} sm={10} md={12}>
          <FormControl style={{ width: "10%" }}>
            <Button
              color="warning"
              variant="contained"
              style={{ height: 27 }}
              onClick={themphuhieu}
            >
              Thêm
            </Button>
          </FormControl>
          <FormControl style={{ width: "17%", marginLeft: 10 }}>
            <Button
              color="primary"
              variant="contained"
              style={{ height: 27 }}
              disabled={disableBT}
              onClick={capnhatphuhieu}
            >
              Cập nhật
            </Button>
          </FormControl>
          <FormControl style={{ width: "10%", marginLeft: 10 }}>
            <Button
              color="error"
              variant="contained"
              style={{ height: 27 }}
              disabled={disableBT}
              onClick={xoaphuhieu}
            >
              Xóa
            </Button>
          </FormControl>
        </GridItem>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatphuhieu.propTypes = {
  bienkiemsoat: PropTypes.string,
};
export default Capnhatphuhieu;
